import React, { useState } from 'react';
import { Sparkles, Users, Book, Globe2, Play, Star, Clock, Search, Menu, X } from 'lucide-react';

const HomePage = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  return (
    <>
      

      <main className="min-h-screen">
        {/* Hero Section */}
        <div style={{ backgroundColor: '#751fab' }} className="min-h-screen">
          <div className="container mx-auto px-4 py-12">
            <div className="text-center">
              <img 
                src="/logofncflor.png"
                alt="Nueva Consciencia Logo"
                className="w-[200px] h-[110px] mx-auto mb-4"
              />
              <h1 className="text-4xl md:text-6xl font-bold text-white mb-4">
                Fundación Nueva Consciencia
              </h1>
              <p className="text-xl md:text-2xl text-white mb-12">
                La Escuela de Metafísica más influyente del mundo hispano
              </p>
              <div className="grid grid-cols-1 md:grid-cols-4 gap-6 mb-12">
                <div style={{ backgroundColor: '#ad4bed' }} className="rounded-lg p-6">
                  <Globe2 className="w-12 h-12 text-white mx-auto mb-4" />
                  <div className="text-3xl font-bold text-white">95Mill+</div>
                  <div className="text-white">Personas alcanzadas</div>
                </div>
                
                <div style={{ backgroundColor: '#ad4bed' }} className="rounded-lg p-6">
                  <Users className="w-12 h-12 text-white mx-auto mb-4" />
                  <div className="text-3xl font-bold text-white">2Mill+</div>
                  <div className="text-white">Alumnos en Programas gratuitos</div>
                </div>
                <div style={{ backgroundColor: '#ad4bed' }} className="rounded-lg p-6">
                  <Users className="w-12 h-12 text-white mx-auto mb-4" />
                  <div className="text-3xl font-bold text-white">200K+</div>
                  <div className="text-white">Alumnos avanzados</div>
                </div>
                <div style={{ backgroundColor: '#ad4bed' }} className="rounded-lg p-6">
                  <Book className="w-12 h-12 text-white mx-auto mb-4" />
                  <div className="text-3xl font-bold text-white">10K+</div>
                  <div className="text-white">Estudiantes semanales</div>
                </div>
              </div>
              <div className="mb-12">
                <h2 className="text-2xl font-semibold text-white flex items-center justify-center gap-2 mb-4">
                  <Sparkles className="w-6 h-6" />
                  Libera tu fuerza interior
                </h2>
                <p className="text-lg text-white mb-6">
                  Hipnosis · Reiki · Sanación Energética · Meditación · PNL · Y mucho mas
                </p>
                <p className="text-white text-lg max-w-4xl mx-auto leading-relaxed">
                  Con un Acervo de más de 500 cursos de alto impacto y con un enorme poder transformacional, Nuestro equipo de 10 Instructores y 10 profesores impartimos semana a semana en vivo diferentes programas de formación en todo el continente Americano. Únete y descubre todo lo que podemos hacer para ti.
                </p>
              </div>
              <a href="https://chat.whatsapp.com/E49jnRxwC2aG7jjhphvU63" target="_blank" rel="noopener noreferrer" className="inline-block bg-white text-[#751fab] font-bold py-4 px-8 rounded-full text-lg hover:bg-purple-50 transition-colors">
                Comienza tu viaje espiritual
              </a>
            </div>
          </div>
        </div>

        {/* About Section */}
        <div className="bg-white">
          <div className="py-16 px-4">
            <div className="container mx-auto">
              <div className="max-w-4xl mx-auto text-center mb-16">
                <h2 className="text-4xl font-bold text-[#751fab] mb-8">
                  ¿Quién es Fundación Nueva Consciencia?
                </h2>
                <p className="text-xl text-gray-600 mb-8">
                  Con sede en Asuncion, operaciones en 8 países y más de 2 Millones de Alumnos en Latino américa, 
                  Fundación Nueva Consciencia es la escuela de Metafísica de mayor influencia e impacto de habla hispana.
                </p>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
                  <div className="bg-[#751fab]/5 rounded-xl p-8">
                    <h3 className="text-xl font-semibold text-[#751fab] mb-4">Nuestra Misión</h3>
                    <p className="text-gray-600">
                      Nuestra misión es ayudarte a desarrollar todo tu potencial espiritual y personal para conseguir 
                      las metas y los objetivos que te plantees en tu vida a través de las técnicas más avanzadas de 
                      crecimiento espiritual y personal.
                    </p>
                  </div>
                  <div className="bg-[#751fab]/5 rounded-xl p-8">
                    <h3 className="text-xl font-semibold text-[#751fab] mb-4">Nuestro Respaldo</h3>
                    <p className="text-gray-600">
                      Nuestros Cursos y talleres están respaldados por el seminario de Cultura de Paz de las Naciones Unidas,
                      garantizando la calidad y efectividad de nuestra enseñanza.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Video Intro Section */}
          <div style={{ backgroundColor: '#751fab' }} className="py-12 px-4">
            <div className="container mx-auto">
              <div className="max-w-4xl mx-auto text-center">
                <h2 className="text-3xl md:text-4xl font-bold text-white mb-6">
                  ¿Te imaginas transformar tu vida en solo 13 minutos?
                </h2>
                <p className="text-xl text-white mb-8">
                  En este video te explico como tu puedes participar en los cursos, descubre cómo miles de personas están cambiando sus vidas a través de nuestras enseñanzas en desarrollo espiritual y personal, a demas tendras testimonios de personas reales hablando de situaciones reales.
                </p>
                <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-8">
                  <div style={{ backgroundColor: '#ad4bed' }} className="rounded-lg p-6">
                    <Clock className="w-8 h-8 text-white mx-auto mb-2" />
                    <p className="text-white font-semibold">7 minutos</p>
                    <p className="text-white text-sm">Guía completa paso a paso</p>
                  </div>
                  <div style={{ backgroundColor: '#ad4bed' }} className="rounded-lg p-6">
                    <Users className="w-8 h-8 text-white mx-auto mb-2" />
                    <p className="text-white font-semibold">6 minutos</p>
                    <p className="text-white text-sm">Testimonios reales</p>
                  </div>
                  <div style={{ backgroundColor: '#ad4bed' }} className="rounded-lg p-6">
                    <Star className="w-8 h-8 text-white mx-auto mb-2" />
                    <p className="text-white font-semibold">2M+ estudiantes</p>
                    <p className="text-white text-sm">nos respaldan</p>
                  </div>
                </div>
                <div className="bg-white/10 rounded-lg p-6 mb-8">
                  <h3 className="text-white font-semibold mb-4">En este video descubrirás:</h3>
                  <ul className="text-white text-left space-y-3 max-w-xl mx-auto">
                    <li className="flex items-start gap-2">
                      <div className="w-6 h-6 rounded-full bg-white/20 flex-shrink-0 flex items-center justify-center text-white">✓</div>
                      <span>Cómo más de 2 millones de personas han transformado sus vidas con nuestros programas gratuitos</span>
                    </li>
                    <li className="flex items-start gap-2">
                      <div className="w-6 h-6 rounded-full bg-white/20 flex-shrink-0 flex items-center justify-center text-white">✓</div>
                      <span>El proceso simple para comenzar tu desarrollo espiritual con nosotros</span>
                    </li>
                    <li className="flex items-start gap-2">
                      <div className="w-6 h-6 rounded-full bg-white/20 flex-shrink-0 flex items-center justify-center text-white">✓</div>
                      <span>Conoceras algunos de los 10 instructores expertos que te guiarán en tu camino y algunos de los profesores que trabajan con ellos.</span>
                    </li>
                    <li className="flex items-start gap-2">
                      <div className="w-6 h-6 rounded-full bg-white/20 flex-shrink-0 flex items-center justify-center text-white">✓</div>
                      <span>Testimonios inspiradores de estudiantes que ya han vivido la experiencia</span>
                    </li>
                  </ul>
                </div>
                {/* Video */}
                <div className="flex justify-center w-full max-w-4xl mx-auto aspect-video mb-8">
                  <iframe 
                    width="100%" 
                    height="100%" 
                    src="https://www.youtube.com/embed/xa-IujFNRvE?si=wJjrZVYeEKCUD0aj" 
                    title="YouTube video player" 
                    frameBorder="0" 
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" 
                    referrerPolicy="strict-origin-when-cross-origin"
                  ></iframe>
                </div>
                <a href="https://chat.whatsapp.com/E49jnRxwC2aG7jjhphvU63" target="_blank" rel="noopener noreferrer" className="inline-block bg-white text-[#751fab] font-bold py-4 px-8 rounded-full text-lg hover:bg-purple-50 transition-colors">
                  Comienza tu viaje espiritual
                </a>
              </div>
            </div>
          </div>
        </div>
      </main>
    </>
  );
};

export default HomePage;